import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export class ErrorHandlers {

  public static errorHandler(error: HttpErrorResponse): Observable<never> {
    console.error('error occured!');
    return throwError(error);
  }
}
